import type { App } from 'vue'
import { createPinia } from 'pinia'
import { router } from '@/router'
import { setGoogleMapsApp } from '@/lib/googleMapsPlugin'
import { initSentry } from '@/sentry'

export async function init(app: App): Promise<void> {
  const pinia = createPinia()
  app.use(pinia)
  app.use(router)
  await router.isReady()
  initSentry(app, router)
  setGoogleMapsApp(app)
}
